module.exports = __webpack_public_path__ + "static/media/Scroll down.de3873a4.svg";